<script>
import { getShadowColor, getPageThemeColor } from '@/utils/modules/getStyles'

export default {
  name: 'Module9Item',
  props: {
    memo: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'primary'
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getShadowColor, getPageThemeColor }
}
</script>

<template>
  <div
    class="item"
    :class="{'item-large': size === 'large'}"
    :style="{boxShadow: `-5px 5px 0px ${getPageThemeColor(path)}`,
             borderColor: `${getPageThemeColor(path)}`}"
  >
    <p class="item-title">{{ memo || '' }}</p>
    <p class="item-name" :style="{color: `${getPageThemeColor(path)}`}">—— {{ name || '' }}</p>
  </div>
</template>

<style lang="scss" scoped>
.item {
  width: 338px;
  height: 135px;
  border-radius: 5px;
  background-color: #fff;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: -5px 5px 0px #69B5C1;
  border: 1px solid;
  .item-title {
    width: 308px;
    height: 80px;
    font-size: 14px;
    line-height: 26px;
    text-indent: 2em;
    overflow-y: scroll;
    overflow-x: hidden;
    &::-webkit-scrollbar { // chrome/safari
      display: none;
    }
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // IE10+
  }
  .item-name {
    width: 308px;
    font-size: 17px;
    text-align: end;
    font-family: xinwei;
    margin-top: 10px;
  }
}
.item-large {
  width: 510px;
  height: 170px;
  .item-box {
    width: 500px;
    height: 156px;
  }
  .item-title {
    width: 460px;
    height: 90px;
  }
  .item-name {
    width: 460px;
    text-align: end;
  }
}
</style>
